import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  allRights: {
    id: 'components.CopyrightText.allRights',
    defaultMessage: 'Patent Pending. All Rights Reserved.',
  },
  support: {
    id: 'components.CopyrightText.support',
    defaultMessage: 'Contact support: ',
  },
});
